<!--
 * @Description: 修改派单权对话框组件
 * @Author: wanqian
 * @Date: 2022-05-05 14:45:33
-->
<template>
  <el-dialog class="cansel-dispatch-pvg" width="896px" center title="取消派单权" :visible.sync="visible" :close-on-click-modal="false"
    @open="initData" :before-close="handleCancel" center>
    <div class="dialog-content">
			<div class="div-discomplete-order">
				<div class="div-order-header">
					<div class="div-order-header-left">
						<div class="blue-vertical-line"></div>
						<span class="item-title">未完成的订单</span>
						<span v-if="cancleDispatchMessage" class="item-subtitle">
							{{'（' + cancleDispatchMessage.attendantName + '有未完成的订单，需要转移后才能取消派单权）'}}
						</span>
					</div>
					<div v-if="!isExpandOrder" class="div-order-header-right" @click="handleExpandOrder">
						<span>点击展开</span>
						<img src="../../../assets/instmng/attendantlist/img-attendant-expand.png" alt="">
					</div>
					<div v-else class="div-order-header-right" @click="handleExpandOrder">
						<span>点击收起</span>
						<img src="../../../assets/instmng/attendantlist/img-attendant-fold.png" alt="">
					</div>
				</div>
				<div v-if="isExpandOrder">
					<el-table style="margin: 32px 0; border: 1px solid #f0f0f0;" ref="table" 
						:data="cancleDispatchMessage.orderDTOList" header-cell-class-name="table-header-color">
						<el-table-column prop="no" label="订单号" min-width="25%" align="center"></el-table-column>
						<el-table-column label="住院科室" min-width="25%" align="center">
							<template slot-scope="scope">
								{{scope.row.department1Text + ' ' + scope.row.department2Text + "（" + scope.row.hospitalText + "）"}}
							</template>
						</el-table-column>
						<el-table-column label="服务时间" min-width="25%" align="center">
							<template slot-scope="scope">
								<div>{{dateFormate(scope.row.startTime) + ' 至 '}}</div>
								<div>
									{{dateFormate(scope.row.endTime) + ' 共' + scope.row.duration}}
									{{ scope.row.durationType ? '小时' : '天' }}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="服务对象" min-width="25%" align="center">
							<template slot-scope="scope">
								<span>{{scope.row.servdePersonName}}</span>
								<span>{{scope.row.servedPersonGender == '未知' ? '' : (' ' + scope.row.servedPersonGender)}}</span>
								<span>{{scope.row.servdePersonAge == 0 ? '' : (' ' + scope.row.servdePersonAge + '岁')}}</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div class="div-dispatch-pvg">
				<div class="div-order-header">
					<div class="div-order-header-left">
						<div class="blue-vertical-line"></div>
						<span class="item-title">派单权限</span>
						<span v-if="cancleDispatchMessage" class="item-subtitle">
							{{'（' + cancleDispatchMessage.attendantName + '需转移的权限）'}}
						</span>
					</div>
					<div v-if="!isExpandDispatch" class="div-order-header-right" @click="handleExpandDispatch">
						<span>点击展开</span>
						<img src="../../../assets/instmng/attendantlist/img-attendant-expand.png" alt="">
					</div>
					<div v-else class="div-order-header-right" @click="handleExpandDispatch">
						<span>点击收起</span>
						<img src="../../../assets/instmng/attendantlist/img-attendant-fold.png" alt="">
					</div>
				</div>
				<div v-if="isExpandDispatch" style="margin-top: 32px;">
					<dispatch-tree :hospitalDepartmentDOList="hospitalDepartmentDOList" :hospitalHserviceDOList="hospitalHserviceDOList" />
				</div>
			</div>
			<div class="attendant-list-back">
				<div class="div-attendant-header">
					<div class="div-attendant-header-left">
						<div class="blue-vertical-line"></div>
						<span class="item-title">选择转移人员</span>
					</div>
					<div class="div-attendant-header-right">
						<el-input placeholder="请输入人员姓名" v-model="filterParams.nameOrPhoneOrIdno" clearable size="mini"></el-input>
						<el-button type="primary" size="mini" icon="el-icon-search" style="margin-left: 10px;" @click="handleQuery">搜索</el-button>
					</div>
				</div>
			</div>
			<div class="attendant-list" v-if="cancleDispatchMessage">
				<div class="attendant-item" v-for="(item, index) in dataTable" 
					:key="item.id" @click="handleAttendantChoose(item, index)">
					<div class="attendant-item-left">
						<div>{{item.name}}</div>
						<div>{{item.mobile}}</div>
						<div>{{item.levelText}}</div>
						<div v-if="item.privilegeTextList && item.privilegeTextList.indexOf('派单') != -1" class="dispatch-tag">
							派单
						</div>
					</div>
					<div class="attendant-item-right">
						<img :src="item.select ? require('../../../assets/instmng/attendantlist/img-attendant-select.png') 
							: require('../../../assets/instmng/attendantlist/img-attendant-disselect.png')" alt="">
					</div>
				</div>
				<div  v-if="!dataTable.length" style="text-align: center;">暂无数据</div>
			</div>
			<div style="text-align: right; margin-bottom: 10px;">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage" 
					:current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize" 
					layout="total, prev, pager, next, sizes, jumper" :total="totalNumber" />
			</div>
			<div v-if="currentSelectAttendant" class="confirm-name">
				{{'确认转移后，订单将转移给' + currentSelectAttendant.name + '，并被赋予派单权'}}
			</div>
    </div>
    <div class="bk-wizard-bottons" style="text-align: center;">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'
import DispatchTree from './dispatchpvg/DispatchTree.vue'

export default {
  name: 'CancleDispatchPrivilegeDialog',

  props: ["visible", "id", "institutionId", "cancleDispatchMessage", "hospitalDepartmentDOList", "hospitalHserviceDOList"],

	components: {
    'dispatch-tree': DispatchTree,
  },

  data() {
    return {
      isExpandOrder: false,
			isExpandDispatch: false,
			currentSelectAttendant: null,
			dataTable: [],
			filterParams: {
				reviewStatus: 1,
				status: 1,
        page: 1,
        pageSize: 5,
      },
      pageSizes: [5,10,20,30,50],
			totalNumber: 0,
    }
  },

  methods: {
    async initData() {
			this.isExpandOrder = false;
			this.isExpandDispatch = false;
			this.currentSelectAttendant = null;
			this.filterParams.excludeAttendantId = this.id;
			this.filterParams.institutionId = this.institutionId;

			await this.getAttendantsList();
			this.dataTable.forEach((item) => {
				this.$set(item, 'select', false)
			});
    },

    handleExpandOrder() {
      this.isExpandOrder = !this.isExpandOrder;
    },

		handleExpandDispatch() {
			this.isExpandDispatch = !this.isExpandDispatch;
		},

		handleAttendantChoose(item, _index) {
			this.dataTable.forEach((itemList) => {
				itemList.select = false;
			});
			item.select = true;
			this.currentSelectAttendant = item;
		},

		getAttendantsList() {
      return new Promise((resolve) => {
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams({...this.filterParams},
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
            method: 'GET',
            url: Constant.URL_PAGE_ATTENDANTS,
            param: esParam,
            header: header,
            contentType: this.commonConst.CNTYPE_URLENCODED,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
		},

		handleQuery() {
			this.filterParams.page = 1;
			this.getAttendantsList();
		},

    handleCancel() {
			this.dataTable = []
			this.filterParams = {
				reviewStatus: 1,
				status: 1,
        page: 1,
        pageSize: 5,
      };
			this.totalNumber = 0
      this.$emit("close-dialog", false);
    },

    handleSubmit() {
			if (!this.currentSelectAttendant) {
				this.$message.error('选择转移人员');
				return;
			}
      this.$emit("close-dialog", true, this.currentSelectAttendant.id);
    },

		dateFormate(date) {
      return this.dateUtil.dateFormat(date);
    },

		//以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.getAttendantsList();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.getAttendantsList();
    },
  },
}
</script>

<style scoped>

.cansel-dispatch-pvg .div-order-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
}
.cansel-dispatch-pvg .div-order-header-left {
	display: flex;
	flex: 1;
	align-items: center;
}
.cansel-dispatch-pvg .blue-vertical-line {
	margin-right: 12px;
	width: 4px;
	height: 13px;
	background-color: #2A98FF;
	border-radius: 1px;
}
.cansel-dispatch-pvg .item-title {
	font-size: 15px;
	font-weight: 600;
	color: #000000;
}
.cansel-dispatch-pvg .item-subtitle {
	font-size: 13px;
	font-weight: 400;
	color: #666666;
}
.cansel-dispatch-pvg .div-order-header-right {
	display: flex;
}
.cansel-dispatch-pvg .div-order-header-right span {
	font-size: 15px;
	color: #409EFF;
}
.cansel-dispatch-pvg .div-order-header-right img {
	margin-left: 8px;
	width: 20px;
	height: 20px;   
}
.cansel-dispatch-pvg .attendant-list-back {
	margin-top: 33px;
}
.cansel-dispatch-pvg .div-dispatch-pvg {
	margin-top: 33px;
}
.cansel-dispatch-pvg .div-attendant-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
}
.cansel-dispatch-pvg .div-attendant-header-left {
	display: flex;
	flex: 1;
	align-items: center;
}
.cansel-dispatch-pvg .div-attendant-header-right {
	display: flex;
}
.cansel-dispatch-pvg .attendant-list {
	margin: 29px 0;
}
.cansel-dispatch-pvg .attendant-item {
	padding: 16px 33px 16px 13px;
	margin-bottom: 4px;
	border-bottom: 1px solid #E2E2E2;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.cansel-dispatch-pvg .attendant-item-left {
	display: flex;
	align-items: center;
	font-size: 15px;
	line-height: 26px;
	color: #000000;
	flex: 1;
}
.cansel-dispatch-pvg .attendant-item-left :nth-child(1) {
	max-width: 250px;
}
.cansel-dispatch-pvg .attendant-item-left :nth-child(2), .attendant-item-left :nth-child(3), .attendant-item-left :nth-child(4) {
	margin-left: 20px;
}
.cansel-dispatch-pvg .dispatch-tag {
	min-width: 54px;
	width: 54px;
	height: 26px;
	line-height: 24px;
	border-radius: 13px;
	box-sizing: border-box;
	border: 1px solid #4482F6;
	font-size: 15px;
	color: #606267;
	text-align: center;
}
.cansel-dispatch-pvg .attendant-item-right {
	margin-left: 10px;
	display: flex;
	align-items: center;
}
.cansel-dispatch-pvg .attendant-item-right img {
	min-width: 20px;
	width: 20px;
	height: 20px;
	border-radius: 10px;
}
.cansel-dispatch-pvg .confirm-name {
	font-size: 14px;
	color: #FFA800;
}
.cansel-dispatch-pvg .dialog-footer {
	margin-bottom: 40px;
}
.cansel-dispatch-pvg >>> .el-dialog--center .el-dialog__body {
    padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/CancleDispatchPrivilegeDialog.vue